import React from 'react';
import styled from 'styled-components';
import { Box } from '@mui/material';

export const MainCtn = styled.div`
    // border: 1px solid black;
    width: 99vw;
    // padding: 1em;
    height: auto;
    margin-top: 5em;
`;